import { faBrainCircuit } from "@fortawesome/pro-solid-svg-icons/faBrainCircuit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CardContent, Grid } from "@mui/material";
import { MprcCard, MprcContainer, MprcJoinComponents, MprcText } from "components";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useTranslation } from "react-i18next";
import { DefaultAuthor } from "views/knowledge/components/card/behaviors/common/DefaultAuthor";
import { useCardContext } from "../../CardBuilder";

///////////////////////////////////////////////////////////////////////////////////////

export const ModeratePublicationAuthor = () => {
    const {
        pub: { moderatePublication }
    } = useCardContext();

    const { t } = useTranslation("knowledge");

    return (
        <>
            {
                moderatePublication?.aiAnalysis?.recommended === false &&
                <MprcContainer >
                    <MprcCard paperColor="notice">
                        <CardContent>
                            <Grid container justifyContent="center" alignItems="center" spacing={1}>
                                <Grid size="grow">
                                    <MprcFeedTypography variant="authorCaption">
                                        {t("Feed.Card.ModeratePublications.AiAnalysisTitle")}:
                                    </MprcFeedTypography>

                                    <ul style={{ margin: 0 }}>
                                        {
                                            (moderatePublication?.aiAnalysis?.analysisReasons ?? []).map((reason, index) =>
                                                <li key={index}>
                                                    <MprcFeedTypography variant="authorPrimary">
                                                        {reason}
                                                    </MprcFeedTypography>
                                                </li>
                                            )
                                        }
                                        {
                                            moderatePublication?.aiAnalysis?.analysisWords != null &&
                                            <li>
                                                <MprcFeedTypography variant="authorPrimary">
                                                    <span>{t("Feed.Card.ModeratePublications.AiAnalysisWords")}:&nbsp;</span>
                                                </MprcFeedTypography>
                                                <MprcFeedTypography variant="authorSecondary">
                                                    <MprcJoinComponents
                                                        components={moderatePublication?.aiAnalysis?.analysisWords.map(item => <b><i>{item}</i></b>)}
                                                        separatorVariant="comma"
                                                    />
                                                </MprcFeedTypography>
                                            </li>
                                        }
                                    </ul>

                                </Grid>
                                <Grid>
                                    <MprcText color="muted">
                                        <FontAwesomeIcon icon={faBrainCircuit} size="2x" />
                                    </MprcText>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </MprcCard>
                </MprcContainer>
            }

            <DefaultAuthor />
        </>
    );
};
